import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useAppSelector} from '@/hooks';

interface PageGridSizeOptionProps {
  isDisabled?: boolean;
}

export function PageGridSizeOption({isDisabled}: PageGridSizeOptionProps): ReactElement | null {
  const gridSize = useAppSelector((state) => {
    return state.posterEditor.posterObject?.grid.size;
  });

  if (gridSize === undefined) {
    return null;
  }

  const onChangeHandler = (val: number): void => {
    void window.posterEditor?.whiteboard?.updateFromObject(
      {
        grid: {
          size: val,
        },
      },
      {
        undoable: false,
      }
    );
  };

  return (
    <ContextualMenuSliderOptions
      id="grid-size-slider-option"
      value={gridSize}
      label={window.i18next.t('pmwjs_size')}
      range={{min: 10, max: 100}}
      transformDisplay={{min: 10, max: 100}}
      onChange={onChangeHandler}
      isDisabled={isDisabled}
    />
  );
}
